import instance,{BASE_URL}from "../../services/api";
import toast from 'react-hot-toast';

const AppraisalViewController =() =>{
  const getErrorMessage = (error) => {
  return (
    error.response?.data?.detail ||   // Django REST Framework style
    error.response?.data?.message ||  // custom backend message
    error.response?.data?.error ||    // another fallback
    error.message ||                  // Axios default
    "Something went wrong!"
  );
};

    const getEmployeeForAppraisalCycle = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}employees-for-appraisal/`,
        {}
      );
      // console.log("Fetching attendance with params:", params);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_EMPLOYEE_FOR_APPRAISAL_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
       const message = getErrorMessage(error);
      dispatch({
        type: "GET_EMPLOYEE_FOR_APPRAISAL_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };


    const getAppraisalCycle = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}appraisal-cycles/`,
        {}
      );
      // console.log("Fetching attendance with params:", params);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_APPRAISAL_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
       const message = getErrorMessage(error);
      dispatch({
        type: "GET_APPRAISAL_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };

  const addAppraisalCycle = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}appraisal-cycles/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_APPRAISAL_SUCCESS", payload: data });
      dispatch(getAppraisalCycle());
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
       const message = getErrorMessage(error);
      dispatch({
        type: "ADD_APPRAISAL_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };

   const updateAppraisalCycle = (appraisalId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}appraisal-cycles/${appraisalId}/`,
        reqData
      );
      const data = response.data;
      // const jsonString = JSON.stringify(response.data);
      // const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_APPRAISAL_SUCCESS", payload: data });
      dispatch(getAppraisalCycle());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Appraisal data updated successfully");
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_APPRAISAL_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };

  const deleteAppraisalCycle = (appraisalId) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.delete(
        `${BASE_URL}appraisal-cycles/${appraisalId}/`
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "DELETE_APPRAISAL_SUCCESS", payload: data });
      dispatch(getAppraisalCycle());
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
       const message = getErrorMessage(error);
      dispatch({
        type: "DELETE_APPRAISAL_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };
 
 const getAppraisalReview = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}appraisal-reviews/`,
        {}
      );
      // console.log("Fetching attendance with params:", params);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_APPRAISAL_REVIEW_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
       const message = getErrorMessage(error);
      dispatch({
        type: "GET_APPRAISAL_REVIEW_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };

  const addAppraisalReview = (reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.post(
        `${BASE_URL}appraisal-reviews/`,
        reqData
      );

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      dispatch({ type: "ADD_APPRAISAL_REVIEW_SUCCESS", payload: data });
      dispatch(getAppraisalReview());
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "ADD_APPRAISAL_REVIEW_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };

  const updateAppraisalReview = (appraisalId, reqData) => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.put(
        `${BASE_URL}appraisal-reviews/${appraisalId}/`,
        reqData
      );
      const data = response.data;
      // const jsonString = JSON.stringify(response.data);
      // const data = JSON.parse(jsonString);
      dispatch({ type: "UPDATE_APPRAISAL_REVIEW_SUCCESS", payload: data });
      dispatch(getAppraisalReview());
      dispatch({ type: "LOADING", payload: false });
      toast.success("Review updated successfully");
      return data;
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "UPDATE_APPRAISAL_REVIEW_FAILURE",
        payload: { error: error },
      });
      toast.error(message);
    }
  };
   const getAppraisalHistory = () => async (dispatch) => {
    dispatch({ type: "LOADING", payload: true });
    try {
      const response = await instance.get(
        `${BASE_URL}appraisal-cycles/history/`,
        {}
      );
      // console.log("Fetching attendance with params:", params);

      const jsonString = JSON.stringify(response.data);
      const data = JSON.parse(jsonString);
      // console.log("Fetched attendance data:", response.data);
      dispatch({ type: "GET_APPRAISAL_HISTORY_SUCCESS", payload: data });
      dispatch({ type: "LOADING", payload: false });
    } catch (error) {
      dispatch({ type: "LOADING", payload: false });
      const message = getErrorMessage(error);
      dispatch({
        type: "GET_APPRAISAL_HISTORY_FAILURE",
        payload: { error: error }
      });
      toast.error(message);
    }
  };


  return{
    getEmployeeForAppraisalCycle, 
    getAppraisalCycle, 
    addAppraisalCycle, 
    updateAppraisalCycle, 
    deleteAppraisalCycle,
    getAppraisalReview,
    addAppraisalReview,
    updateAppraisalReview,
    getAppraisalHistory
  };

};

export default AppraisalViewController;